import {createRouter, createWebHistory, RouterView} from 'vue-router'
import HomePage from "@/pages/home-page.vue";
import translation from "@/core/helpers/translations.js";
import LoginPage from "@/pages/login-page.vue";
import RegisterPage from "@/pages/register-page.vue";
import ContactPage from "@/pages/contact-page.vue";
import ForgotPasswordPage from "@/pages/forgot-password-page.vue";
import NewPasswordPage from "@/pages/new-password-page.vue";
import ProfilePage from "@/pages/profile-page.vue";
import ProfileOrders from "@/components/profile/profile-orders.vue";
import ProfileInfo from "@/components/profile/profile-info.vue";
import {checkAuth} from "@/core/guards/notAuthGuard.js";
import ProfileTopup from "@/components/profile/profile-topup.vue";
import StorePage from "@/pages/store-page.vue";
import ProductPage from "@/pages/product-page.vue";
import CartPage from "@/pages/cart-page.vue";
import WishlistPage from "@/pages/wishlist-page.vue";
import TermsPage from "@/pages/terms-page.vue";
import PolicyPage from "@/pages/policy-page.vue";
import FaqPage from "@/pages/faq-page.vue";
import SearchPage from "@/pages/search-page.vue";

const routes = [
  {
    path: '/:locale?',
    component: RouterView,
    beforeEnter: translation.routeMiddleware,
    children: [
      {
        path: '',
        name: 'home',
        component: HomePage,
        meta: {
          title: "Home"
        }
      },
      {
        path: 'activate-user',
        name: 'activate-user',
        component: HomePage,
        meta: {
          title: "Home"
        }
      },
      {
        path: 'payment',
        name: 'payment',
        component: HomePage,
        meta: {
          title: "Home"
        }
      },
      {
        path: 'search',
        name: 'search',
        component: SearchPage,
        meta: {
          title: "Search"
        }
      },
      {
        path: 'contact',
        name: 'contact',
        component: ContactPage,
        meta: {
          title: "Contact"
        }
      },
      {
        path: 'login',
        name: 'login',
        component: LoginPage,
        meta: {
          title: 'Sign In'
        }
      },
      {
        path: 'register',
        name: 'register',
        component: RegisterPage,
        meta: {
          title: 'Sign Up'
        }
      },
      {
        path: 'forgot-password',
        name: 'forgot-password',
        component: ForgotPasswordPage,
        meta: {
          title: 'Forgot password'
        }
      },
      {
        path: 'reset-password',
        name: 'reset-password',
        component: NewPasswordPage,
        meta: {
          title: "New password"
        }
      },
      {
        path: 'store/:category',
        name: 'store',
        component: StorePage,
        meta: {
          title: "Store"
        }
      },
      {
        path: 'product/:productUuid',
        name: 'product',
        component: ProductPage,
        meta: {
          title: "Product"
        }
      },
      {
        path: 'cart',
        name: 'cart',
        component: CartPage,
        meta: {
          title: "Cart"
        }
      },
      {
        path: 'wishlist',
        name: 'wishlist',
        component: WishlistPage,
        meta: {
          title: "Wishlist"
        }
      },
      {
        path: 'profile',
        name: 'profile',
        component: ProfilePage,
        beforeEnter: checkAuth,
        meta: {
          title: "Profile"
        },
        children: [
          {
            path: 'orders',
            name: 'profile-orders',
            component: ProfileOrders,
          },
          {
            path: 'info',
            name: 'profile-info',
            component: ProfileInfo,
          },
          {
            path: 'topup',
            name: 'profile-topup',
            component: ProfileTopup,
          }
        ]
      },
      {
        path: 'terms-and-conditions',
        name: 'terms-and-conditions',
        component: TermsPage,
        meta: {
          title: "Terms and Conditions"
        }
      },
      {
        path: 'privacy-policy',
        name: 'privacy-policy',
        component: PolicyPage,
        meta: {
          title: "Privacy Policy"
        }
      },
      {
        path: 'faq',
        name: 'faq',
        component: FaqPage,
        meta: {
          title: "FAQ"
        }
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
  scrollBehavior() {
    document.querySelector('#top').scrollIntoView({ behavior: 'smooth' })
    return {
      top: 0,
      left: 0,
      behavior: 'smooth'
    }
  }
})

router.beforeEach((to, from) => {
  document.title = to.meta.title ? 'FindProTemplates | ' + to.meta?.title : 'FindProTemplates'
})

export default router
